import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/app/hooks";
import type { UserRole } from "@/types";

interface RoleGuardProps {
  allowedRoles: UserRole[];
  children: React.ReactNode;
}

export function RoleGuard({ allowedRoles, children }: RoleGuardProps) {
  const user = useAppSelector((state) => state.auth.user);
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  const isDebtorsRoute =
    location.pathname === "/debtors" ||
    location.pathname.startsWith("/debtors/");

  if (isDebtorsRoute && user.role === "agent") {
    return <>{children}</>;
  }

  const canAccess = allowedRoles.includes(user.role);

  if (!canAccess) {
    const fallback =
      user.role === "super_admin"
        ? "/super-admin"
        : user.role === "agent"
          ? "/agent-portal"
          : "/dashboard";
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
